module.exports = __webpack_public_path__ + "static/media/view-equal.c0f2b172.svg";